export class DataLayerHelper
{
    constructor(data_layer, ecommerce_events) {
        this.data_layer = data_layer;

        this.clearDataLayer();
        this.pushEvents(ecommerce_events);
    }

    clearDataLayer() {
        if ('undefined' === typeof this.data_layer || null === this.data_layer) {
            return;
        }

        this.data_layer.push({ecommerce: null});
    }

    pushEvents(events) {
        events.forEach(event => {
            this.pushEvent(event);
        })
    }

    pushEvent(event) {
        if ('undefined' === typeof this.data_layer || null === this.data_layer) {
            return;
        }

        this.data_layer.push(event);
    }
}
